export const enum StorageEvents {
  CURRENT_USER = 'CURRENT_USER',
}
